import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
import api from "@services/apiList";
import { emptyError, ResponseType } from "../../Types/ServicesType/servicesType";
const { clinicId } = getConstants()
const { walletapi } = api;

type Filter = {
  search: string;
};

export type PatientsListRequestData = {
  clinicId: number;
  filter: Filter;
  pageNumber: number;
  pageSize: number;
};

export const getPatientsList = async (body: PatientsListRequestData) => {
  try {
    const result = await instance.post(walletapi.getPatientsList, body);
    return result.data.response;
  } catch (error) {
    return emptyError;
  }
};

export const getPatientsListExcel = async (
  body: PatientsListRequestData,
): Promise<ResponseType<string | null>> => {
  try {
    const result = await instance.post(walletapi.getPatientsListExcel, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};

export const getModeOfPayment = async () => {
  try {
    const result = await instance.get(walletapi.ModeOfPayment);
    return result.data.response;
  } catch (error) {
    return emptyError;
  }
};
export const getAmount = async (patientId: number) => {
  try {
    const result = await instance.get(
      `${walletapi.getWalletAmount}${patientId}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
export const saveWallet = async (body: {
  patientId: number | null;
  modeOfPaymentId: number;
  amount: number;
}) => {
  try {
    const result = await instance.post(walletapi.saveWallet, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
export const printReceipt = async (id: number) => {
  try {
    const result = await instance.get(
      `${walletapi.printReceipt}${id}?clinicId=${clinicId}`
    );
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
export const getWalletDetails = async (body: any) => {
  try {
    const result = await instance.post(`${walletapi.walletStatement}`, body);
    return result.data;
  } catch (error) {
    return emptyError;
  }
};
